




















































































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  LinkedCardState,
  AchVerifier,
  Card,
} from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import Input from "@/shared/components/ui/Input.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import LoadingSpinner from "@/shared/components/ui/LoadingSpinner.vue";
import Search from "@/shared/components/Search.vue";
import { Validator } from "vee-validate";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import NoAccountMessage from "@/employee/components/NoAccountMessage.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import LinkedBankAccounts from "@/employee/components/settings/linkedAccounts/LinkedBankAccounts.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    Button,
    RadioButton,
    Input,
    TabGroup,
    Tab,
    LoadingSpinner,
    Search,
    NoAccountMessage,
    SettingsNavigation,
    LinkedBankAccounts,
    SettingsHeader,
  }
})
export default class LinkedAccounts extends Vue {
  $validator: Validator;

  bankAccountStore = useBankAccountStore();
  partnerPortalStore = usePartnerPortalStore();
  custodianSettingStore = useCustodianSettingsStore();
  themeStore = useThemeStore();
  featureFlagStore = useFeatureFlagStore();

  // just to prevent the page from blowing up for now.
  // TODO this should be fixed / removed
  bankAccount = null;

  showConfirmDeleteCardModal = false;
  showConfirmDeleteLoginModal = false;
  cardToDelete = null;
  loginIdToDelete = null;

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingStore.portalFunctionalityDisabled;
  }

  get showLinkedAccounts () {
    return !this.custodianSettingStore.isHsaBankCustodian;
  }
  get showHsabLinkedAccounts () {
    return this.custodianSettingStore.isHsaBankCustodian;
  }

  get showLinkHealthExpenses () {
    return !this.custodianSettingStore.isHsaBankCustodian;
  }

  get achVerifierIsFinicity () {
    return this.bankAccountStore.achVerifier === AchVerifier.Finicity;
  }
  get achVerifierIsUmb () {
    return this.bankAccountStore.achVerifier === AchVerifier.Umb;
  }
  get achVerifierIsLoading () {
    return this.bankAccountStore.achVerifier === AchVerifier.None;
  }
  get linkCardButtonText () {
    return this.bankAccountStore.isLinkedCardIframeLoading ? "Loading..." : "Link Another Card";
  }

  get isLinkCardDisabled (): boolean {
    if (this.portalFunctionalityDisabled) {
      return true;
    }

    return this.bankAccountStore.isLinkedCardIframeLoading
      || this.bankAccountStore.linkedCardState === LinkedCardState.Loading
      || this.bankAccountStore.linkedCardState === LinkedCardState.Delete;
  }

  get hasLinkedCards () {
    return this.bankAccountStore.linkedCardViewIsList && this.bankAccountStore.linkedCards.length > 0;
  }

  get isLinkedCardsInDeleteState () {
    return this.bankAccountStore.linkedCardState === LinkedCardState.Delete;
  }

  linkBankVerifyForm = {
    verifyAmount1: 0,
    verifyAmount2: 0
  };

  created () {
    const finicity = document.createElement("script");
    finicity.setAttribute("src", "https://connect2.finicity.com/assets/sdk/finicity-connect.min.js");
    document.head.appendChild(finicity);
  }

  mounted () {
    this.bankAccountStore.loadBankAccountState();
    this.partnerPortalStore.getPartnerPortalStatus();
    if (this.custodianSettingStore.isHsaBankCustodian === false) {
      this.bankAccountStore.retrieveLinkedCardNeedsMaintenance();
    }
  }

  onTabChange () {
    return false;
  }

  bankNameToClass (name) {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .join("");
  }

  toggleLinkCard (isMaintenance: boolean) {
    if (this.bankAccountStore.linkedCardState !== LinkedCardState.Loading && !isMaintenance) {
      this.bankAccountStore.retrieveLinkFinancialCardUrl().then(() => {
        this.handleIframe(isMaintenance);
      });
    }
    else if (this.bankAccountStore.linkedCardState !== LinkedCardState.Loading && isMaintenance) {
      this.bankAccountStore.retrieveLinkFinancialCardMaintenanceUrl().then(() => {
        this.handleIframe(isMaintenance);
      });
    }
    else {
      this.handleIframe(isMaintenance);
    }
  }

  toggleDeleteLinkedCard () {
    this.bankAccountStore.setLinkedCardState(LinkedCardState.Delete);
  }

  cancelDeleteLinkedCards () {
    this.bankAccountStore.setLinkedCardState(LinkedCardState.List);
  }

  handleIframe (isMaintenance: boolean) {
    if (this.bankAccountStore.linkedCardViewIsForm && this.bankAccountStore.linkedCards.length > 0) {
      this.bankAccountStore.destroyIFrame(window);
      return;
    }

    if (this.bankAccountStore.linkedCardState !== LinkedCardState.Form) {
      this.bankAccountStore.setLinkedCardState(LinkedCardState.Form);
      this.bankAccountStore.connectIFrame({ window, isMaintenance });
    } else if (this.bankAccountStore.linkedCardViewIsForm) {
      this.bankAccountStore.destroyIFrame(window);
    }
  }

  showConfirmDeleteCard (card) {
    this.showConfirmDeleteCardModal = true;
    this.cardToDelete = card;
  }

  showConfirmDeleteLogin (loginId: number) {
    this.showConfirmDeleteLoginModal = true;
    this.loginIdToDelete = loginId;
  }

  confirmDeleteLoginId () {
    this.bankAccountStore.deleteLinkedLogin(this.loginIdToDelete);
    this.showConfirmDeleteLoginModal = false;
  }

  confirmDeleteLinkedCard () {
    this.bankAccountStore.deleteLinkedcard(this.cardToDelete);
    this.showConfirmDeleteCardModal = false;
  }

  onClose () {
    this.showConfirmDeleteCardModal = false;
    this.showConfirmDeleteLoginModal = false;
  }

  cancelDeleteLinkedCard () {
    this.showConfirmDeleteCardModal = false;
  }

  cancelDeleteLinkedLogin () {
    this.showConfirmDeleteLoginModal = false;
  }

  get nonOAuthLinkedCards (): Card[] {
    return this.bankAccountStore.linkedCards.filter(c => c.oAuthInstitutionLoginId === null);
  }

  get oAuthLoginIds (): number {
    const loginIds = this.bankAccountStore.linkedCards.filter(
      c => c.oAuthInstitutionLoginId !== null).map(c => c.oAuthInstitutionLoginId
      );
    return loginIds.filter((n, i) => loginIds.indexOf(n) === i) as any;
  }

  linkedCardsForLoginId (loginId: number): Card[] {
    return this.bankAccountStore.linkedCards.filter(c => c.oAuthInstitutionLoginId === loginId);
  }

  isMultipleLinkedCardsForLoginId (loginId: number): boolean {
    return this.bankAccountStore.linkedCards.filter(c => c.oAuthInstitutionLoginId === loginId).length !== 1;
  }
}
